import create from 'zustand';
import { persist } from 'zustand/middleware';
import { string } from 'yup';

type socioI={
  email?: string;
  msg?: string;
  Activo?: boolean;
  numColaborador?: string;
}
type asociateStore = {
  datos: socioI | null;
  verificado: boolean;

  guardarDatos: (asociado: socioI) => void;
  marcarVerificado: (val: boolean) => void;
  resetear: () => void;
};

export const useAsociadoStore = create(
  persist<asociateStore>(
    (set) => ({
      datos: null,
      verificado: false,

      // Guarda todos los datos del asociado
      guardarDatos: (asociado: socioI) =>
        set({
          datos: asociado,
         // verificado: false, // Resetear verificación al guardar nuevos datos

        }),
      // Marca como verificado
      marcarVerificado: (val: boolean) => set({ verificado: val }),

      // Resetea todo el estado
      resetear: () =>
        set({
          datos: null,
          verificado: false,

        }),
    }),
    {
      name: 'asociado-storage',
      getStorage: () => sessionStorage,
    }
  )
);
